import React from 'react';
import { ASSETS } from '../game/constants';

const StatsBoard = ({ stats, winCounts, totalRounds }) => {
  const winTotal = winCounts.reduce((a, b) => a + b, 0);

  return (
    <div className="w-full grid grid-cols-3 gap-2 md:gap-4 mb-2">
      {stats.map((count, i) => {
        const winRate = winTotal > 0 ? Math.round((winCounts[i] / winTotal) * 100) : 0;
        return (
          <div key={i} className="hud-glass rounded-xl md:rounded-2xl p-2.5 md:p-4 flex items-center justify-between overflow-hidden relative group">
            {/* 背景動態進度條 */}
            <div 
              className="absolute left-0 top-0 bottom-0 opacity-10 transition-all duration-700 ease-out" 
              style={{ 
                backgroundColor: ASSETS.COLORS[i], 
                width: `${(count / 66) * 100}%` 
              }} 
            />
            
            <div className="relative flex items-center gap-2 md:gap-3">
              <span className="text-xl md:text-3xl drop-shadow-[0_0_12px_rgba(255,255,255,0.3)]">
                {ASSETS.EMOJIS[i]}
              </span>
              <div className="flex flex-col">
                <span className="text-sm md:text-xl font-black font-mono leading-none text-white/95">
                  {count}
                </span>
                <span className="text-[8px] md:text-[10px] font-black text-white/50 uppercase tracking-wider mt-0.5">
                  ALIVE
                </span>
              </div>
            </div>

            <div className="relative text-right flex flex-col items-end">
              <div className="text-[10px] md:text-sm font-black text-white/80 leading-none">
                {winRate}%
              </div>
              <div className="text-[8px] md:text-[10px] font-black text-white/40 uppercase tracking-wider mt-0.5">
                WINS
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsBoard;